import React from 'react';
import { styled } from 'baseui';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { LabelMedium } from 'baseui/typography';
import { AccessTypeGroup } from '../../../utils/dashboardUtils';

const ChartContainer = styled('div', {
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  padding: '20px',
  minHeight: '400px',
  display: 'flex',
  flexDirection: 'column',
});

const ChartHeader = styled('div', {
  marginBottom: '16px',
});

const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff8042', '#a4de6c'];

interface AccessTypeChartProps {
  data: AccessTypeGroup[];
}

export const AccessTypeChart: React.FC<AccessTypeChartProps> = ({ data }) => {
  return (
    <ChartContainer>
      <ChartHeader>
        <LabelMedium margin={0}>Access by Type</LabelMedium>
      </ChartHeader>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="type" />
          <YAxis />
          <Tooltip
            formatter={(value: number, name: string, props: any) => [
              `${value} (${props.payload.percentage.toFixed(1)}%)`,
              'Count'
            ]}
          />
          <Bar dataKey="count" radius={[8, 8, 0, 0]}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};
